/** 本文件由工具自动生成,请勿手动修改！ **/
// @ts-nocheck
import { useState,  useEffect } from 'react';
import * as R from 'ramda';
import Request, { YWRequestConfig } from '@ywfe/request';
import { getHost, reduceParams, parseParams, querystring } from '@ywfe/utils';


const { basePath = '', loginPath = '' } = getHost("PRO_SETTLE", "522")


  
    
export interface API47790Item {
  
  /** 项目编号 */
  projectNo?: string;
  
  /** 项目名称 */
  name?: string;
  
  /** 项目logo图片url */
  logo?: string;
  
  /** 项目描述 */
  desc?: string;
  
  /** 项目级别：1:超S级2:S级3:A级4:B级 */
  level?: number;
  
  /** 项目阶段：1:成熟2:孵化3:筹备 */
  growStatus?: number;
  
};
    
  



export interface API47790Req {
  
  /** 项目编号 */
  projectNo?: string;
    
  /**  */
  pageSize?: string;
    
  /**  */
  pageIndex?: string;
    
  /**  */
  rowId?: string;
    
  /**  */
  jumpType?: string;
    
  /**  */
  searchCount?: string;
    
  /**  */
  orderObjects?: string;
    
};



export interface API47790Res {
  /** 项目编号  */
  projectNo?: string;
  /** 项目名称  */
  name?: string;
  /** 项目logo图片url  */
  logo?: string;
  /** 项目描述  */
  desc?: string;
  /** 项目级别：1:超S级2:S级3:A级4:B级  */
  level?: number;
  /** 项目阶段：1:成熟2:孵化3:筹备  */
  growStatus?: number;
  /** 项目状态（1：正常；2：风险；3：失控）  */
  projectStatus?: number;
  /** 项目进度  */
  projectProgress?: any;
  /**   */
  projectProgressDesc?: string;
  /** 时间进度  */
  timeProgress?: any;
  /**   */
  timeProgressDesc?: string;
  /** 项目开始日期  */
  projectStartDate?: any;
  /** 项目结束日期  */
  projectEndDate?: any;
  /** 是否长期：0.非长期(默认)1.长期  */
  isLongTime?: number;
  /** 负责人信息 ,UserResp  */
  master?: any;
  /** 组织架构（部门名）  */
  organization?: string;
  /** 主业务 ,ProjectBaseResp  */
  parentProject?: any;
  /** 子业务列表 ,ProjectBaseResp  */
  subProjectList?: API47790Item[];
  /** 项目汇报提醒 ,ProjectReportRemindParam  */
  projectReportRemindParam?: any;
  /** 健康标志：0-10  */
  healthFlag?: number;
  /** 业务分类：1.基础业务2.创新业务3.投资业务  */
  businessType?: number;
  /** 类型：1.项目(默认)2.任务  */
  projectType?: number;
  /** 当前项目的主业务,默认0  */
  parentProjectNo?: string;
  /** 主业务名称  */
  parentProjectName?: string;
  /** 启用状态：1.启用2.停用  */
  enableStatus?: number;
  /** 是否可查看  */
  read?: boolean;
  /** 是否可编辑  */
  edit?: boolean;
  /** 是否可删除  */
  delete?: boolean;
  /** 是否可下载  */
  download?: boolean;
  
};


// 47790 获取项目详情--基本信息

export interface IUseGetAPI47790Return {
  /** 获取项目详情--基本信息: 接口请求状态 */
  isAPI47790Loading: boolean;
  /** 获取项目详情--基本信息: 接口请求返回数据 */
  dataAPI47790: API47790Res;
  /**  获取项目详情--基本信息: 接口数据请求方法 */
  fetchAPI47790Data:  (inputs: API47790Req, config?: YWRequestConfig) => Promise<API47790Res>;
  /** 获取项目详情--基本信息: 接口请求URL */
  requestUrl: string;
}

export const useGetAPI47790 = ():IUseGetAPI47790Return => {
  let isMount = true;
  const [isAPI47790Loading, setIsAPI47790Loading] = useState(false);
  const [dataAPI47790, setDataAPI47790] = useState<API47790Res>({} as API47790Res);
  const requestUrl = `${basePath}/corp-admin/project/detail`;

  const fetchAPI47790Data = async (inputs: API47790Req, config?: YWRequestConfig): Promise<API47790Res> => {
  
    
    const params = (reduceParams(inputs as unknown as R.Dictionary<API47790Req>) || {}) as API47790Req;
    
  
    if ( isMount ) {
      setIsAPI47790Loading(true);
    }

    try {
      
      
      const res: any = await Request.get<API47790Res>(`${basePath}/corp-admin/project/detail?${querystring.stringify(params as any)}`, {
        loginHost: loginPath,
        ...config
      });
      
      
      
      if (isMount) {
        setDataAPI47790(res || {} as API47790Res);
        setIsAPI47790Loading(false);
      }
      return res;
    } catch (error) {
      console.error('[ERROR] API Request Error: ', error);
      if ( isMount ) {
        setIsAPI47790Loading(false);
      }
      return false as unknown as API47790Res;
    }
  }

  useEffect(() => {
    return () => {
      isMount = false;
    };
  }, []);

  return {
    isAPI47790Loading,
    dataAPI47790,
    fetchAPI47790Data,
    requestUrl,
  }
}

